import { useAppSelector } from '../hooks';
import { selectEvents } from '../reducers/eventsSlice';

export function useEvents() {
  const events = useAppSelector((state) => selectEvents(state)) ?? [];
  return { events };
}
